import React, { useState, useEffect, useRef } from "react";
import "./LoginPage.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { login, verifyLoginOtp } from "../../controllers/accounts/Account";
import { notification } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InfoCircleOutlined } from "@ant-design/icons";
import { faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons';

const kcHighLogo = "/images/kc-high-logo.png";

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location?.state ;

  const inputRef = {
    email: useRef(null),
    password: useRef(null),
  };

  const ADMINDATA = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));
  const TOKEN = sessionStorage.getItem("TOKEN");
  const [formData, setFormData] = useState({
    email: localStorage.getItem("LOGIN_EMAIL")
      ? atob(localStorage.getItem("LOGIN_EMAIL"))
      : "",
    password: localStorage.getItem("LOGIN_PASSWORD")
      ? atob(localStorage.getItem("LOGIN_PASSWORD"))
      : "",
  });
  const [isOTPSent, setIsOTPSent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState('');
  const [sessionError,setSessionError]=useState(state||"")
  const [success, setSuccess] = useState("");
  const [countdown, setCountdown] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  /*************************************************************
   * Function Name  : handleChange
   * Purposs        : This function is used for store input value in states
   * Created Date   : 08-01-2024
   *************************************************************/
  const handleChange = (e) => {
   
    setFormData((preVal) => ({
      ...preVal,
      [e.target.name]: e.target.value,
    }));
    setSessionError('')
    setErrors((...preError) => ({
      ...preError,
      [e.target.name]: "",
    }));
  }; //End of FUnction

  /*************************************************************
   * Function Name  : handleLogin
   * Purposs        : This function is used generate login OTP
   * Created Date   : 08-01-2024
   *************************************************************/
  const handleLogin = async () => {
    if (isSubmitting) return; // already in flight -- ignore repeat clicks
    try {
      if (!formData?.email) {
        setErrors((prevError) => ({
          ...prevError,
          email: "Email is required.",
        }));
        return;
      } else if (!formData.password) {
        setErrors((prevError) => ({
          ...prevError,
          password: "Password is required.",
        }));
        return;
      }

      setIsSubmitting(true);
      const options = { email: formData?.email, password: formData.password };
      const result = await login(options);

      if (result.status == true) {
        setIsOTPSent(true);

        setSuccess((prevSuccess) => ({
          ...prevSuccess,
          formSuccess: result.message,
        }));
        setCountdown(60);
        setIsCounting(true);
      } else {
        setIsOTPSent(false);
        setErrors((prevError) => ({
          ...prevError,
          formError: result.message,
        }));
      }
    } catch (error) {
      console.error("Error during login process:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  /*************************************************************
   * Function Name  : handleVerifyOTP
   * Purposs        : This function is used handle verify otp
   * Created Date   : 08-01-2024
   *************************************************************/
  const handleVerifyOTP = async () => {
    if (isSubmitting) return; // already in flight -- ignore repeat clicks
    try {
      if (!formData?.email) {
        setErrors((...preError) => ({
          ...preError,
          email: "Email is required.",
        }));
      } else if (!formData.otp) {
        setErrors((...preError) => ({
          ...preError,
          otp: "OTP is required.",
        }));
      } else {
        setIsSubmitting(true);
        // const web_device_id = await generateToken();
        const web_device_id = '';
        const options = {
          email: formData?.email,
          otp: formData.otp,
          ...(web_device_id ? { web_device_id: web_device_id } : null),
        };
        const result = await verifyLoginOtp(options);
        if (result.status === true) {
          if (formData?.remember_me && formData?.email && formData?.password) {
            // localStorage.setItem('LOGIN_EMAIL', btoa(formData?.email));
            // localStorage.setItem('LOGIN_PASSWORD', btoa(formData?.password));
          }
          navigate("/dashboard");
        } else {
          // setErrors((...preError) => ({
          //   ...preError,
          //   formError: "Somthing went wrong! Please try after some time.",
          // }));
          notification.open({
            message: "Opps!",
            description: `${result?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
      setErrors((...preError) => ({
        ...preError,
        formError: "error",
      }));
    } finally {
      setIsSubmitting(false);
    }
  }; //End of Function

  /*************************************************************
   * Function Name  : handleEmailChange
   * Purposs        : This function is used for change email id
   * Created Date   : 08-01-2024
   *************************************************************/
  const handleEmailChange = async () => {
    //Empty OTP Input Box
    setFormData((preVal) => ({
      ...preVal,
      password: "",
      otp: "",
    }));
    setIsOTPSent(false);
    setCountdown(0);
  }; //End of Function

  /*************************************************************
   * Purposs        : This hooks is used for handle otp sent countdown
   * Created Date   : 08-01-2024
   *************************************************************/
  useEffect(() => {
    const TOKEN = sessionStorage.getItem("TOKEN");
    if(!TOKEN){
      return
    }
    if (ADMINDATA || TOKEN) {
      navigate("/dashboard");
    }
    let countdownInterval;
    if (isCounting) {
      countdownInterval = setInterval(() => {
        if (countdown > 0) {
          setCountdown((prevCountdown) => prevCountdown - 1);
        } else {
          clearInterval(countdownInterval);
          setIsCounting(false);
        }
      }, 1000);
    } else {
      clearInterval(countdownInterval);
    }
    return () => {
      clearInterval(countdownInterval);
    };
  }, [countdown, isCounting]);

  /*************************************************************
   * Purposs        : This hooks is used for handle key press on email input
   * Created Date   : 20-01-2024
   *************************************************************/
  // For Email
  const handleEmailKeyPress = (event) => {
    if (event.key === "Enter") {
      if (inputRef.password.current) {
        inputRef.password.current.focus();
      }
    }
  };
  //For Password
  const handlePasswordKeyPress = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };
  //For One Time Password
  const handleOtpKeyPress = (event) => {
    if (event.key === "Enter") {
      handleVerifyOTP();
    }
  };
  //End of Function

  // useEffect(() => {
  //   Notification.requestPermission().then(function (permission) {
  //     if (permission === "granted") {
  //       // Create a notification
  //       //var notification = new Notification('Welcome Back!');
  //     } else {
  //       // Otherwise, we can fallback to a regular alert
  //       alert("You need to allow notifications to use notification feature.");
  //     }
  //   });
  // }, []);

  // console.log('errors',errors?.formError)
  return (
    <section className="vh-100 kc_login_section">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 text-black kc_login_bg">
            <div className="d-flex align-items-center justify-content-center h-custom-2 px-5 ms-xl-4  pt-5 pt-xl-0 mt-xl-n5 frisbee_login_login">
              <form className="kc_login_card" style={{ width: "23rem" }}>
                <div className="kc_login_brand_band">
                  <img
                    src={kcHighLogo}
                    alt="KC High"
                    className="kc_login_logo"
                  />
                </div>
                <div className="login_main_heading">
                  <h3
                    className="fw-normal mb-3 pb-3 login_div"
                    style={{ letterSpacing: "1px", textAlign: "center" }}
                  >
                    <span className="login_div">Admin Log in</span>
                  </h3>
                </div>
                {!isOTPSent && (
                  <>
                    <div className="form-outline mb-2">
                      <label
                        className="form-label email_address_login"
                        htmlFor="email "
                      >
                        <span style={{ color: "red" }}>*</span>Email Address
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control form-control-lg input_login_page"
                        onKeyDown={handleEmailKeyPress}
                        onChange={handleChange}
                        value={formData?.email}
                      />
                      {errors?.email ? (
                        <p style={{ color: "red" }}>{errors?.email}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-outline mb-2">
                      <label
                        className="form-label email_address_login"
                        htmlFor="password"
                      >
                        <span style={{ color: "red" }}>*</span>Password
                      </label>
                      <div className="input-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          id="password"
                          name="password"
                          className="form-control form-control-lg input_login_page"
                          onChange={handleChange}
                          ref={inputRef.password}
                        />
                        <span
                          className="input-group-text my_eye_icon"
                          onClick={togglePasswordVisibility}
                        >
                          {showPassword ? (
                            <FontAwesomeIcon icon={faEyeSlash} />

                          ) : (
                            <FontAwesomeIcon icon={faEye} />
                          )}
                        </span>
                      </div>
                     
                      {sessionError?.[0]?.message||sessionError?.message &&  <p style={{ color: "red" }}>{sessionError?.[0]?.message||sessionError?.message}</p>}
                      {errors?.password ? (
                        <p style={{ color: "red" }}>{errors?.password}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div class="row mb-2">
                      <div className="login_page_reset_password">
                        <div class="col">
                        </div>
                        <div class="col" className="reset_login_page">
                          <Link to="/reset-password" className="reset_button">
                            Reset Password?
                          </Link>
                        </div>
                      </div>
                    </div>

                    <div className="pt-1 mb-2">
                      {errors?.formError ? (
                        <p style={{ color: "red", textAlign: "center" }}>
                          {errors?.formError}
                        </p>
                      ) : (
                        ""
                      )}
                      <Link to={false} onClick={handleLogin}>
                        <button
                          type="submit"
                          disabled={isSubmitting}
                          style={{
                            backgroundColor: "var(--kc-maroon, #a23333)",
                            color: "white",
                            borderRadius: "20px",
                          }}
                          className="btn btn-block mb-3 login_btn_btn"
                        >
                          {isSubmitting ? "Logging in..." : "Login"}
                        </button>
                      </Link>
                    </div>
                  </>
                )}

                {isOTPSent && (
                  <>
                    <h3
                      className="fw-normal login_div verify_otp_text"
                      style={{ letterSpacing: "1px", textAlign: "center", fontSize: "20px" }}
                    >
                      Verify OTP
                    </h3>
                    {success?.formSuccess ? (
                      <p style={{ color: "black", textAlign: "center" }}>
                        {success?.formSuccess}{" "}
                        <Link
                          to={false}
                          onClick={handleEmailChange}
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          Change
                        </Link>
                      </p>
                    ) : (
                      ""
                    )}
                    <div className="form-outline mb-2">
                      <label
                        className="form-label email_address_login"
                        htmlFor="otp"
                      >
                        <span style={{ color: "red" }}>*</span>OTP
                      </label>
                      <input
                        type="password"
                        id="otp"
                        name="otp"
                        className="form-control form-control-lg input_login_page"
                        onChange={handleChange}
                        ref={inputRef.otp}
                      />
                      {errors?.otp ? (
                        <p style={{ color: "red" }}>{errors?.otp}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div class="row mb-2">
                      <div className="login_page_reset_password">
                        <div class="col">
                          <div class="form-check">
                            <label
                              class="form-check-label remember_login_page"
                              for="form2Example31"
                              style={{ color: "red" }}
                            >
                              {" "}
                              {isCounting ? (
                                `Resend OTP in ${countdown ? countdown : 0}`
                              ) : (
                                <></>
                              )}
                            </label>
                          </div>
                        </div>
                        <div class="col" className="reset_login_page">
                          {isCounting ? (
                            <></>
                          ) : (
                            <Link
                              to={false}
                              onClick={handleLogin}
                              className="reset_button"
                            >
                              {" "}
                              Resend OTP?
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="pt-1 mb-2">
                      <Link to={false} onClick={handleVerifyOTP}>
                        <button
                          type="submit"
                          disabled={isSubmitting}
                          style={{
                            backgroundColor: "var(--kc-maroon, #a23333)",
                            color: "white",
                            borderRadius: "20px",
                          }}
                          className="btn btn-block mb-3 login_btn_btn"
                        >
                          {isSubmitting ? "Verifying..." : "Login"}
                        </button>
                      </Link>
                    </div>
                  </>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoginPage;
